<template>
  <button
    ref="refButtonScreen"
    class="button-white button-icon button-icon-bigger button-rounded"
    @click="handleManualRedirect"
  >
    <IconGuide class="icon-medium" />
  </button>
</template>

<script setup lang="ts">
import IconGuide from '@/components/icons/IconGuide.vue';
import { useGtag } from '@/composables/shared/useGtag';
import { useUserStore } from '@/stores/user';
import { TypeCall } from '@/types/common';
import redirectToManualPage from '@/utils/redirectToManualPage';

const route = useRoute();

const userStore = useUserStore();

const { trackEventClick } = useGtag();

const lang = computed<'ko' | 'en'>(() => {
  return userStore.pageLanguage === 'ko' ? 'ko' : 'en';
});

const chatType = computed<TypeCall>(() => {
  return route.meta.chatType;
});

const handleManualRedirect = () => {
  trackEventClick('chat', ' 이용가이드');
  redirectToManualPage(lang.value, chatType.value);
};
</script>

<style scoped lang="scss">
button {
  &.button-icon-bigger {
    display: inline-flex;
    width: fit-content;
    height: fit-content;
    gap: 0.5rem;
    font-family: inherit;
    font-weight: 500;
    justify-content: center;
    align-items: center;
    padding: 0.75rem;
    opacity: 1;
    word-break: keep-all;
    flex-shrink: 0;
    border-radius: 50%;
    transition:
      box-shadow 0.75s ease,
      background-color 0.75s ease;
    cursor: pointer;
    color: $color-gray-900;
    &:hover {
      background: var(--surface-hover-gray-dimmest);
      box-shadow: 0 0 0 2px var(--surface-hover-gray-dimmest) inset;
    }
  }
}
</style>
